var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1446.39 1533.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -593.35,
    y1: 334.81,
    x2: 1157.83,
    y2: 1843.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#24d0d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6250ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -123.26,
    y1: -210.88,
    x2: 1627.92,
    y2: 1297.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -502.32,
    y1: 229.13,
    x2: 1248.87,
    y2: 1737.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -307.62,
    y1: 3.13,
    x2: 1443.56,
    y2: 1511.71,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1446.39,1421.7c0,41.07-23.02,76.39-56.55,94.45-4.76,2.58-9.92,4.76-15.08,6.55l-140.68-81.75-777.62-451.61-14.48-8.33-302.99,173.62v240.29h164.1v-164.49l138.9-79.57v382.96H.08v-459.55l442.48-253.59,861.16,500.22,140.88,81.75c1.19,6.15,1.79,12.5,1.79,19.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1442.22 285.93 1442.22 1224.47 441.97 643.29 104.06 836.75 35 716.31 442.37 482.76 1303.32 983.19 1303.32 362.52 1127.32 251.6 1127.32 678.41 988.43 597.65 988.43 0 1127.32 87.51 1303.32 198.42 1442.22 285.93"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 104.65,
    cy: 752.01,
    r: 104.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1446.31,1421.8c0,46.83-29.96,86.51-71.63,101-11.11,3.97-23.02,6.15-35.32,6.15-52.58,0-96.43-37.9-105.36-87.9-1.19-6.15-1.79-12.7-1.79-19.25,0-46.63,29.76-86.11,71.43-100.8,11.11-3.97,23.22-6.15,35.72-6.15,52.58,0,96.23,37.9,105.16,87.9,1.19,6.15,1.79,12.5,1.79,19.05Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7b2450aa1a10ebfdc690346e9921c771.svg";
export { ForwardRef as ReactComponent };